import get from 'get-value';
import {claimsWebsocketCommands} from '../../constants/claimsWebsocketCommands';

export const claimsDealers = (state = {
    isLoadingDealer: false,
    dealers: [],
    correlationId: null,
    searchResults: null,
}, action) => {
    switch (action.type) {
        case claimsWebsocketCommands.CLAIMS_DEALERS_GET: {
            const hasSearchTerm = get(action, 'payload.searchTerm');
            return Object.assign({}, state, { 
                isLoadingDealer: !hasSearchTerm // Don't show loading for search requests
            });
        }
        case claimsWebsocketCommands.CLAIMS_DEALERS_SEND: {
            const dealers = get(action, 'payload.dealers', { default: [] });
            const correlationId = get(action, 'payload.correlationId');
            
            // If this response has a correlationId starting with 'search_', it's from a search request
            if (correlationId && correlationId.includes('search_')) {
                return Object.assign({}, state, {
                    searchResults: { 
                        dealers: dealers.map(dealer => ({...dealer})), // Deep copy each dealer object
                        correlationId 
                    }
                });
            }
            
            // Regular dealer loading
            return Object.assign({}, state, {
                isLoadingDealer: false,
                dealers: dealers.map(dealer => ({...dealer})), // Deep copy each dealer object
            });
        }
        case claimsWebsocketCommands.CLAIMS_DEALERS_SEND_ERROR: {
            return Object.assign({}, state, {isLoadingDealer: false});
        }
        default:
            return state;
    }
};
